import React from 'react';
import './FD.css';
import FMSimage from '../Assets/fire1.jpeg'; // First image (full size)
import FMSimage2 from '../Assets/fd2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/fd4.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/fd3.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/fd5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">FIRE DETECTION SYSTEM</h1>
                    <p className="FMS-description">
                    The Fire Detection System (FDS) from Vajra IoT is an advanced solution designed to provide reliable fire detection, real-time alerts, and swift responses. It integrates various fire sensors, alarms, and networks into a unified platform, ensuring enhanced safety in industrial, commercial, and residential environments. The system delivers prompt notifications, empowering users to take immediate action and prevent fire-related damage.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fire Detection" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Instant Alerts:</strong> Provides immediate fire alerts to the designated personnel or control room, enabling fast response times.</li>
                        <li><strong>High Sensitivity:</strong> Equipped with sensitive smoke and heat detectors to detect fires at the earliest stages.</li>
                        <li><strong>Remote Monitoring:</strong> Allows for remote access to the fire detection system, ensuring continuous monitoring even when you're not onsite.</li>
                        <li><strong>Automated Responses:</strong> Automatically triggers alarms and safety mechanisms, such as sprinkler systems or fire doors, to mitigate fire damage.</li>
                        <li><strong>Seamless Integration:</strong> Easily integrates with existing fire safety infrastructure and other building management systems.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Fire Detection Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Centralized Monitoring:</strong> All fire sensors feed data into a centralized control system, providing real-time status updates on the network.</li>
                        <li><strong>Instant Notification:</strong> Upon detecting smoke, heat, or fire, the system instantly notifies the control center or responsible individuals.</li>
                        <li><strong>Integrated Safety Measures:</strong> The system can trigger emergency protocols like alarms, evacuation lights, or sprinklers based on the fire detection status.</li>
                        <li><strong>Data Logging:</strong> All fire-related data is logged for analysis, helping improve future responses and safety measures.</li>
                        <li><strong>Scalable Setup:</strong> Suitable for various environments, from small offices to large industrial facilities, with the ability to scale as needed.</li>
                    </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Fire Detection System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Reliable Detection:</strong> Our system detects fires in real-time, even in challenging environments.</li>
                        <li><strong>Comprehensive Coverage:</strong> Covers a wide range of areas, from industrial plants to residential complexes, ensuring full fire protection.</li>
                        <li><strong>Cost-Effective Safety:</strong> Designed to minimize maintenance and installation costs while providing comprehensive fire safety.</li>
                        <li><strong>Expert Support:</strong> Our team provides ongoing support, ensuring the system operates smoothly and remains effective over time.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FDS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Fire Detection System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using FDS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    The Fire Detection System is a critical safety solution used across various industries to ensure fire safety and prevention. These industries trust our FDS for its reliability and performance:
                    <ul>
                        <li>Manufacturing</li>
                        <li>Energy & Utilities</li>
                        <li>Logistics & Transportation</li>
                        <li>Smart Cities</li>
                        <li>Healthcare (upcoming)</li>
                    </ul>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default FMS;
